import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { fetchAPI } from "../utils/fetchAPI";

interface UseSteelModalProps {
  show: boolean;
  onHide: () => void;
  onSuccess: () => void;
  itemId: number;
  item: {
    name: string;
    steelType: number;
    steelStatus: number;
    width: number;
    height: number;
    thickness: number;
    weight: number;
    grade: string;
    usedTo: string;
    info: string;
  };
}

const UseSteelModal: React.FC<UseSteelModalProps> = ({ show, onHide, onSuccess, itemId, item }) => {
  const [note, setNote] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");

    try {
      const data = await fetchAPI("POST", "updateSteel.php", {
        id: itemId,
        name: item.name,
        steelType: 3,
        steelStatus: 4,
        width: item.width,
        height: item.height,
        thickness: item.thickness,
        weight: item.weight,
        grade: item.grade,
        usedTo: note,
        info: item.info,
      });

      if (data && data.success) {
        onSuccess();
        onHide();
      } else {
        throw new Error(data?.message || "Nie udało się zaktualizować pozycji stali.");
      }
    } catch (error: any) {
      setErrorMessage(error.message || "Wystąpił błąd podczas aktualizacji pozycji.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Potwierdź zużycie stali</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {errorMessage && <div className="text-danger mb-3">{errorMessage}</div>}
          <Form.Group>
            <Form.Label>Uwagi dotyczące zużycia:</Form.Label>
            <Form.Control as="textarea" rows={3} value={note} onChange={(e) => setNote(e.target.value)} required />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Anuluj
          </Button>
          <Button variant="primary" type="submit" disabled={isLoading}>
            {isLoading ? "Zapisywanie..." : "Potwierdź zużycie"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UseSteelModal;
